import { call, put, select } from 'redux-saga/effects';

import {
  getRoundSurveySuccess,
  getRoundSurveyFailure,
  getQuestionBankSuccess,
  getQuestionBankFailure,
  getQuestionBank,
  addNewQuestionSuccess,
  addNewQuestionFailure,
  updateQuestionSuccess,
  updateQuestionFailure,
  setToastOptions,
  slideIn
} from '../actions';

import { getData, postData } from '../../services/API';
import {
  getFullSurveyUrl,
  questionBankUrl
} from '../../services/API/endpoints';

// Template sagas
export function* getRoundSurveySaga({ payload }) {
  const { unitId, templateConfigId, includeArchived } = payload;

  // Select all params data from store
  const { facilityId } = yield select(
    state => state.AuthorizedUser.authorizedUser
  );
  const { facilities } = yield select(state => state.ConfigReducer);

  try {
    // TODO: Throwing ref error here with no matching facility
    const division = facilities
      .filter(facility => facility.facilityId === facilityId)[0]
      .division.replace(/%20/g, '+');

    const { pathname } = window.location;

    let queryParamsObj = {
      templateConfigId,
      includeArchived
    };
    if (pathname.includes('patient')) {
      // Build the params object for patient
      queryParamsObj = { ...queryParamsObj, unitId, division, facilityId };
    }
    // Convert params to a string, build url
    // Call the GET /template/roundSurvey endpoint
    const queryParamsStr = new URLSearchParams(queryParamsObj).toString();
    const surveyUrl = `${getFullSurveyUrl}?${queryParamsStr}`;
    const { data: templateData, status } = yield call(getData, surveyUrl);

    // If successful response add the specific questions to the survey and
    // add the survey data to the store
    if (status === 200) {
      const surveyData = {
        ...templateData,
        questions: templateData.questions || []
      };
      return yield put(getRoundSurveySuccess(surveyData));
    }
    return yield put(getRoundSurveyFailure());
  } catch (error) {
    console.log(error);
    return yield put(getRoundSurveyFailure());
  }
}

export function* getQuestionBankSaga() {
  const url = `${questionBankUrl}`;
  try {
    const { data, status } = yield call(getData, url);
    if (status === 200) {
      return yield put(getQuestionBankSuccess(data));
    }
    return yield put(getQuestionBankFailure());
  } catch (error) {
    console.log(error);
    return yield put(getQuestionBankFailure());
  }
}

export function* addNewQuestionSaga({ payload }) {
  const url = `${questionBankUrl}`;
  try {
    const { status } = yield call(postData, url, payload);
    if (status === 200) {
      yield put(
        setToastOptions({
          msg: 'Question added!',
          feedback: 'success',
          duration: 1000,
          speed: 500
        })
      );
      yield put(slideIn());
      yield put(addNewQuestionSuccess());
      return yield put(getQuestionBank());
    }
    yield put(
      setToastOptions({
        msg: 'Question failed to Post!',
        feedback: 'error',
        duration: null,
        speed: 500,
        question: true
      })
    );
    yield put(slideIn());
    return yield put(addNewQuestionFailure());
  } catch (error) {
    console.log(error);
    yield put(
      setToastOptions({
        msg: 'Question failed to Post!',
        feedback: 'error',
        duration: null,
        speed: 500,
        question: true
      })
    );
    yield put(slideIn());
    return yield put(addNewQuestionFailure());
  }
}

export function* updateQuestionSaga({ payload }) {
  const url = `${questionBankUrl}`;
  try {
    const { status } = yield call(postData, url, payload);
    if (status === 200) {
      yield put(
        setToastOptions({
          msg: 'Question updated!',
          feedback: 'success',
          duration: 1000,
          speed: 500
        })
      );
      yield put(slideIn());
      yield put(updateQuestionSuccess());
      return yield put(getQuestionBank());
    }
    yield put(
      setToastOptions({
        msg: 'Question failed to Update!',
        feedback: 'error',
        duration: null,
        speed: 500,
        question: true
      })
    );
    yield put(slideIn());
    return yield put(updateQuestionFailure());
  } catch (error) {
    console.log(error);
    yield put(
      setToastOptions({
        msg: 'Question failed to Update!',
        feedback: 'error',
        duration: null,
        speed: 500,
        question: true
      })
    );
    yield put(slideIn());
    return yield put(updateQuestionFailure());
  }
}
